import * as React from "react";
import { TooltipApi } from "sb-resp-ui";
export class LeagueIcon extends React.PureComponent {
    constructor(props) {
        super(props);
        this.tooltip = TooltipApi.getInstance().setMessage(this.props.tooltip);
    }
    render() {
        return (React.createElement("div", Object.assign({ className: this.props.className }, this.tooltip, { "data-uat": "div-league-icon" }), this.props.children));
    }
}
//# sourceMappingURL=LiveStreamIcon.js.map